import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getClients } from 'services/ClientService';

import { ApiStatus } from 'constants/enums';
import type { Client } from 'models/client.interface';
import { handleApiErrors } from 'utils/errorUtils';

export interface ClientsState {
  details: {
    data: Client[];
    status: ApiStatus;
  }
}

const initialState: ClientsState = {
  details: {
    data: [],
    status: ApiStatus.idle,
  }
};

export const fetchClients = createAsyncThunk(
  'clients/fetchClients',
  async (_, thunkAPI) => {
    try {
      return await getClients();
    } catch (e) {
      handleApiErrors(e);
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    resetClientsState: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(fetchClients.pending, (state) => {
        state.details = {
          ...state.details,
          status: ApiStatus.loading,
        };
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        const clients = action.payload;

        state.details = {
          data: clients,
          status: ApiStatus.idle,
        };
      })
      .addCase(fetchClients.rejected, (state) => {
        state.details = {
          ...state.details,
          status: ApiStatus.idle,
        };
      });
  }
});

export const {
  resetClientsState,
} = clientsSlice.actions;

export default clientsSlice.reducer;
